/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-13 14:44:49
 * @LastEditTime: 2022-01-13 15:13:32
 * @LastEditors: zhao - 🍉
 * @Description: 租赁合同审批
 * @FilePath: /zhzj-admin/src/services/rentContractApply.js
 */

import request from "../utils/request";

/**
 * 分页查询
 */
export function fetchRentContractApplyList(data) {
    return request({
        url: '/platform/rentContractApplyRecord/find_page',
        method: 'post',
        data
    })
}

/**
 * 流程审批
 */
export function fetchRentContractApplyApproval(data) {
    return request({
        url: '/platform/rentContractApplyRecord/flowApproval',
        method: 'post',
        data
    })
}

/**
 * 获取合同申请记录详情
 */
export function fetchRentContractApplyGet(data) {
    return request({
        url: '/platform/rentContractApplyRecord/getRentContractApplyRecordInfo',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/services/rentContractApply.js